export default __webpack_public_path__ + "static/media/keyHightlight.6a451923.png";